<template>
    <div id="app">
        <Loading v-if="!status.loaded" />
        <div v-else class="container-fluid nopadding">
            <Topbar v-if="status.loggedIn" />
            <Sidebar class="d-none d-md-block sidebar" v-if="status.loggedIn" />
            <div class="maincontent" v-if="status.loggedIn">
                <router-view />
            </div>
            <div v-else class="col-md-12">
                <router-view />
            </div>
        </div>
    </div>
</template>
<script>
import { mapState } from 'vuex';
import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';
import Loading from '@/views/partial/Loading';

export default {
    components: {
        Loading,
        Sidebar,
        Topbar
    },
    computed: {
        ...mapState('account', ['user', 'status'])
    },
    sockets: {
        connect: function() {}
    },
    created() {
        //this.connectSocket(this.user.id);
    },
    methods: {
        connectSocket(id) {
            this.sockets.subscribe('emitNotification' + id, message => {
                let data = JSON.parse(message);
                if (data.data.data.mode === '') {
                    this.Topbar.newNotifications = 1;
                }
            });
        }
    }
};
</script>
